(function () {
  'use strict';

  const BASE_URL = 'https://sia-knowledge-bot-scisa.onrender.com';

  let initialized = false;
  let currentConversationId = null;

  // --- Auth helpers ---

  const SIA_USER_ID = 'usuario_demo_123';

  function isLoggedIn() {
    try {
      const user = JSON.parse(localStorage.getItem('currentUser'));
      return !!(user && user.email);
    } catch (e) { return false; }
  }

  function isAppRoute() {
    return window.location.hash.includes('/app') && !window.location.hash.includes('sign_in');
  }

  function shouldShow() {
    return isAppRoute() && isLoggedIn();
  }

  // --- Injection ---

  function injectStyles() {
    const style = document.createElement('style');
    style.id = 'sia-chatbot-styles';
    style.textContent = `
      * { box-sizing: border-box; }
      #sia-fab {
        position: fixed; bottom: 24px; right: 24px;
        width: 56px; height: 56px; border-radius: 50%;
        background: #0F265C; color: #fff; border: none;
        cursor: pointer; box-shadow: 0 4px 12px rgba(0,0,0,0.3);
        display: flex; align-items: center; justify-content: center;
        z-index: 9999; transition: transform .2s; font-family: 'Segoe UI', sans-serif;
      }
      #sia-fab:hover { transform: scale(1.1); }
      #sia-window {
        position: fixed; bottom: 90px; right: 24px;
        width: 310px; height: 470px;
        background: #f8f9fa; border-radius: 16px;
        box-shadow: 0 8px 32px rgba(0,0,0,0.2);
        display: none; flex-direction: column;
        z-index: 9999; overflow: hidden;
        font-family: 'Segoe UI', sans-serif;
      }
      #sia-window.open { display: flex; }
      #sia-header {
        background: #0F265C; color: #fff;
        padding: 14px 16px; display: flex;
        align-items: center; gap: 10px; flex-shrink: 0;
      }
      #sia-header h3 { font-size: 1rem; font-weight: 600; margin: 0; }
      #sia-header p  { font-size: 0.75rem; opacity: .85; margin: 0; }
      #sia-close {
        margin-left: auto; background: none; border: none;
        color: #fff; font-size: 20px; cursor: pointer; line-height: 1;
      }
      #sia-content { flex: 1; overflow: hidden; position: relative; }
      .sia-view {
        position: absolute; top: 0; left: 0; width: 100%; height: 100%;
        display: none; flex-direction: column; background: #f8f9fa; overflow-y: auto;
      }
      .sia-view.active { display: flex; }
      .sia-sub-header {
        display: flex; align-items: center; justify-content: space-between;
        padding: 12px 16px; background: #fff; border-bottom: 1px solid #e0e0e0;
        position: sticky; top: 0; z-index: 10;
      }
      .sia-sub-header button { background: none; border: none; font-size: 16px; cursor: pointer; color: #0F265C; font-weight: bold; }
      .sia-sub-header h4 { font-size: 0.9rem; color: #333; margin: 0; text-align: center; flex: 1; }
      .sia-sub-header .placeholder { width: 24px; }
      #sia-view-home { padding: 20px 16px; }
      .sia-greeting { text-align: center; margin-bottom: 24px; }
      .sia-greeting h2 { font-size: 1.4rem; color: #0F265C; margin-bottom: 4px; }
      .sia-greeting p { font-size: 0.85rem; color: #666; }
      .sia-card {
        background: #fff; border: 1px solid #e0e0e0; border-radius: 10px;
        padding: 14px; margin-bottom: 10px; cursor: pointer;
        display: flex; justify-content: space-between; align-items: center;
        transition: box-shadow 0.2s, border-color 0.2s;
      }
      .sia-card:hover { border-color: #0F265C; box-shadow: 0 2px 8px rgba(0,0,0,0.05); }
      .sia-card-featured { background: #0F265C; color: #fff; border: none; }
      .sia-card-featured .sia-card-title { color: #fff; }
      .sia-card-featured .sia-card-subtitle { color: rgba(255,255,255,0.8); }
      .sia-card-featured:hover { background: #0a1b42; box-shadow: 0 4px 12px rgba(15,38,92,0.3); border-color: transparent; }
      .sia-card-content { display: flex; flex-direction: column; gap: 2px; }
      .sia-card-title { font-size: 0.9rem; font-weight: 600; color: #333; }
      .sia-card-subtitle { font-size: 0.75rem; color: #777; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 220px; }
      .sia-card-icon { color: #FF6600; font-size: 1.2rem; font-weight: bold; }
      .sia-card-featured .sia-card-icon { color: #fff; }
      #sia-view-ticket-form { padding: 16px; display: flex; flex-direction: column; gap: 12px; }
      .sia-form-group { display: flex; flex-direction: column; gap: 6px; }
      .sia-form-group label { font-size: 0.8rem; font-weight: 600; color: #333; }
      .sia-form-group label span { color: red; }
      .sia-form-group input[type="text"], .sia-form-group select, .sia-form-group textarea {
        width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 6px; font-size: 0.85rem; outline: none;
      }
      .sia-form-group input:focus, .sia-form-group select:focus, .sia-form-group textarea:focus { border-color: #FF6600; }
      .sia-form-group input[type="file"] { font-size: 0.8rem; }
      .sia-btn-submit {
        background: #0F265C; color: #fff; border: none; padding: 12px; border-radius: 8px;
        font-weight: 600; cursor: pointer; margin-top: 10px; transition: background 0.2s;
      }
      .sia-btn-submit:hover { background: #0a1b42; }
      #sia-view-messages-list { padding: 0; }
      .sia-conv-item {
        display: flex; align-items: center; gap: 12px; padding: 16px;
        border-bottom: 1px solid #eee; background: #fff; cursor: pointer; transition: background 0.2s;
      }
      .sia-conv-item:hover { background: #f5f5f5; }
      .sia-conv-avatar {
        width: 40px; height: 40px; background: #FF6600; color: #fff;
        border-radius: 50%; display: flex; align-items: center; justify-content: center;
        font-weight: bold; font-size: 1.2rem; flex-shrink: 0;
      }
      .sia-conv-text { display: flex; flex-direction: column; gap: 2px; flex: 1; overflow: hidden; }
      .sia-conv-text strong { font-size: 0.9rem; color: #333; }
      .sia-conv-text span { font-size: 0.8rem; color: #777; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
      .sia-msg-list-footer { padding: 20px; display: flex; justify-content: center; background: #f8f9fa; }
      .sia-btn-new-msg {
        background: #0F265C; color: #fff; border: none; padding: 10px 20px;
        border-radius: 20px; font-weight: 600; cursor: pointer; font-size: 0.85rem;
        display: flex; align-items: center; gap: 8px;
      }
      #sia-view-chat { background: #f8f9fa; }
      #sia-messages {
        flex: 1; overflow-y: auto; padding: 14px; display: flex; flex-direction: column; gap: 10px;
      }
      .sia-msg { max-width: 85%; padding: 10px 13px; border-radius: 12px; font-size: 0.88rem; line-height: 1.5; word-wrap: break-word; }
      .sia-msg.bot  { background: #fff; border: 1px solid #e0e0e0; align-self: flex-start; border-bottom-left-radius: 3px; }
      .sia-msg.user { background: #0F265C; color: #fff; align-self: flex-end; border-bottom-right-radius: 3px; }
      .sia-msg.typing { color: #999; font-style: italic; }
      .sia-sources { margin-top: 6px; font-size: 0.78rem; }
      .sia-sources a { color: #FF6600; text-decoration: none; display: block; }
      .sia-sources a:hover { text-decoration: underline; }
      .sia-rating-container { display: flex; gap: 10px; margin-top: 10px; border-top: 1px solid #eee; padding-top: 6px; justify-content: flex-end; }
      .sia-rating-btn { background: none; border: none; cursor: pointer; font-size: 16px; opacity: 0.6; transition: opacity 0.2s, transform 0.2s; }
      .sia-rating-btn:hover { opacity: 1; transform: scale(1.1); }
      #sia-suggestions {
        display: flex; flex-wrap: wrap; gap: 6px; padding: 10px 14px;
        background: #f8f9fa; border-top: 1px solid #e0e0e0;
      }
      .sia-suggestion-btn {
        background: #fff; border: 1px solid #FF6600; color: #FF6600;
        padding: 6px 10px; border-radius: 16px; font-size: 0.75rem;
        cursor: pointer; transition: all 0.2s;
      }
      .sia-suggestion-btn:hover { background: #FF6600; color: #fff; }
      #sia-input-area {
        display: flex; gap: 8px; padding: 12px; border-top: 1px solid #e0e0e0;
        background: #fff; margin-top: auto;
      }
      #sia-input {
        flex: 1; border: 1px solid #dadce0; border-radius: 24px;
        padding: 9px 14px; font-size: 0.88rem; outline: none;
      }
      #sia-input:focus { border-color: #FF6600; }
      #sia-send {
        background: #FF6600; color: #fff; border: none; border-radius: 50%;
        width: 38px; height: 38px; cursor: pointer; font-size: 18px;
        display: flex; align-items: center; justify-content: center; flex-shrink: 0;
      }
      #sia-send:disabled { background: #ccc; cursor: default; }
      #sia-bottom-nav {
        display: flex; background: #fff; border-top: 1px solid #e0e0e0;
        padding: 8px 0; justify-content: space-around; flex-shrink: 0;
      }
      .sia-nav-item {
        background: none; border: none; color: #777;
        display: flex; flex-direction: column; align-items: center; gap: 4px;
        cursor: pointer; font-size: 0.7rem; font-weight: 500; flex: 1;
      }
      .sia-nav-item svg { width: 20px; height: 20px; fill: currentColor; }
      .sia-nav-item.active { color: #0F265C; font-weight: 700; }
    `;
    document.head.appendChild(style);
  }

  const BOT_ICON_SVG = `
    <svg width="28" height="28" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g fill="#ffffff">
        <rect x="10" y="40" width="80" height="22" rx="11"/>
        <rect x="46" y="15" width="8" height="20"/>
        <circle cx="50" cy="11" r="6"/>
        <rect x="20" y="25" width="60" height="52" rx="26"/>
        <path d="M 30 65 L 30 86 Q 30 90 35 86 L 55 72 Z"/>
      </g>
      <ellipse cx="36" cy="46" rx="4.5" ry="7.5" fill="#FF6600"/>
      <ellipse cx="64" cy="46" rx="4.5" ry="7.5" fill="#FF6600"/>
      <path d="M 40 60 Q 50 68 60 60" stroke="#FF6600" stroke-width="4.5" stroke-linecap="round" fill="none"/>
    </svg>`;

  const FAB_ICON_SVG = `
    <svg width="36" height="36" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g fill="#ffffff">
        <rect x="10" y="40" width="80" height="22" rx="11"/>
        <rect x="46" y="15" width="8" height="20"/>
        <circle cx="50" cy="11" r="6"/>
        <rect x="20" y="25" width="60" height="52" rx="26"/>
        <path d="M 30 65 L 30 86 Q 30 90 35 86 L 55 72 Z"/>
      </g>
      <ellipse cx="36" cy="46" rx="4.5" ry="7.5" fill="#FF6600"/>
      <ellipse cx="64" cy="46" rx="4.5" ry="7.5" fill="#FF6600"/>
      <path d="M 40 60 Q 50 68 60 60" stroke="#FF6600" stroke-width="4.5" stroke-linecap="round" fill="none"/>
    </svg>`;

  function injectHTML() {
    const container = document.createElement('div');
    container.id = 'sia-chatbot-root';
    container.innerHTML = `
      <button id="sia-fab" title="Asistente SIA">${FAB_ICON_SVG}</button>

      <div id="sia-window">
        <div id="sia-header">
          ${BOT_ICON_SVG}
          <div>
            <h3>SIA Knowledge Bot</h3>
            <p>Asistente oficial · SCISA</p>
          </div>
          <button id="sia-close">✕</button>
        </div>

        <div id="sia-content">
          <div id="sia-view-home" class="sia-view active">
            <div class="sia-greeting">
              <h2>¡Hola! 👋</h2>
              <p>¿Cómo te podemos ayudar hoy?</p>
            </div>
            <div class="sia-card sia-card-featured" id="sia-card-recent">
              <div class="sia-card-content">
                <span class="sia-card-title">Mensaje reciente</span>
                <span class="sia-card-subtitle" id="sia-home-recent-msg">Cargando tu última conversación...</span>
              </div>
              <div class="sia-card-icon">›</div>
            </div>
            <div class="sia-card" id="sia-card-new">
              <div class="sia-card-content">
                <span class="sia-card-title">Enviar un mensaje</span>
              </div>
              <div class="sia-card-icon" style="font-size:1rem;">➤</div>
            </div>
            <div class="sia-card" id="sia-card-ticket">
              <div class="sia-card-content">
                <span class="sia-card-title">Reportar Bug / Mejora</span>
                <span class="sia-card-subtitle">Levanta un ticket al equipo de soporte</span>
              </div>
              <div class="sia-card-icon">🐛</div>
            </div>
          </div>

          <div id="sia-view-messages-list" class="sia-view">
            <div class="sia-sub-header">
              <div class="placeholder"></div>
              <h4>Mensajes Anteriores</h4>
              <div class="placeholder"></div>
            </div>
            <div id="sia-conversations-container">
              <div style="padding:20px;text-align:center;color:#999;font-size:0.85rem;">Cargando historial...</div>
            </div>
            <div class="sia-msg-list-footer">
              <button class="sia-btn-new-msg" id="sia-btn-new-conv">Nueva conversación ➤</button>
            </div>
          </div>

          <div id="sia-view-chat" class="sia-view">
            <div class="sia-sub-header">
              <button id="sia-back-to-list">❮</button>
              <h4 id="sia-chat-header-title">Chat Activo</h4>
              <div class="placeholder"></div>
            </div>
            <div id="sia-messages"></div>
            <div id="sia-suggestions">
              <button class="sia-suggestion-btn" data-text="¿Cómo creo un nuevo proyecto en SIA?">¿Crear proyecto?</button>
              <button class="sia-suggestion-btn" data-text="¿Glosario de actividades?">Glosario de actividades</button>
              <button class="sia-suggestion-btn" data-text="¿Cómo reporto un Bug o Propuesta de Mejora?">Reportar Bug</button>
              <button class="sia-suggestion-btn" data-text="¿Qué es SIA?">¿Qué es SIA?</button>
            </div>
            <div id="sia-input-area">
              <input id="sia-input" type="text" placeholder="Escribe tu pregunta sobre SIA...">
              <button id="sia-send">➤</button>
            </div>
          </div>

          <div id="sia-view-ticket" class="sia-view">
            <div class="sia-sub-header">
              <button id="sia-ticket-back">❮</button>
              <h4>Nuevo Ticket</h4>
              <div class="placeholder"></div>
            </div>
            <div id="sia-view-ticket-form">
              <div class="sia-form-group">
                <label>Título <span>*</span></label>
                <input type="text" id="ticket-title" placeholder="Describe brevemente el bug o mejora">
              </div>
              <div class="sia-form-group">
                <label>Descripción</label>
                <textarea id="ticket-desc" rows="4" placeholder="Describe qué salió mal y cómo reproducirlo..."></textarea>
              </div>
              <div class="sia-form-group">
                <label>Área del producto <span>*</span></label>
                <select id="ticket-area">
                  <option value="">Seleccionar opción...</option>
                  <option value="proyectos">Proyectos</option>
                  <option value="facturacion">Facturación</option>
                  <option value="usuarios">Usuarios</option>
                  <option value="otro">Otro</option>
                </select>
              </div>
              <div class="sia-form-group">
                <label>Adjuntos</label>
                <input type="file" id="ticket-file">
              </div>
              <button class="sia-btn-submit" id="btn-submit-ticket">Enviar ticket</button>
            </div>
          </div>
        </div>

        <div id="sia-bottom-nav">
          <button id="nav-btn-home" class="sia-nav-item active">
            <svg viewBox="0 0 24 24"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>
            Home
          </button>
          <button id="nav-btn-messages-list" class="sia-nav-item">
            <svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"/></svg>
            Mensajes
          </button>
        </div>
      </div>
    `;
    document.body.appendChild(container);
  }

  // --- Widget logic ---

  function openView(viewName) {
    document.querySelectorAll('#sia-chatbot-root .sia-view').forEach(v => v.classList.remove('active'));
    document.querySelectorAll('#sia-chatbot-root .sia-nav-item').forEach(b => b.classList.remove('active'));

    const target = document.getElementById('sia-view-' + viewName);
    if (target) target.classList.add('active');

    const navTarget = document.getElementById('nav-btn-' + viewName);
    if (navTarget) navTarget.classList.add('active');

    if (viewName === 'chat') {
      document.getElementById('nav-btn-messages-list').classList.add('active');
      setTimeout(() => document.getElementById('sia-input').focus(), 100);
      scrollToBottom();
    }
    if (viewName === 'messages-list') fetchConversationsList();
  }

  function toggleWindow() {
    const win = document.getElementById('sia-window');
    const opening = !win.classList.contains('open');
    win.classList.toggle('open');
    if (opening) fetchConversationsList();
  }

  function scrollToBottom() {
    const msgs = document.getElementById('sia-messages');
    if (msgs) msgs.scrollTop = msgs.scrollHeight;
  }

  async function fetchConversationsList() {
    const convContainer = document.getElementById('sia-conversations-container');
    const homeRecent = document.getElementById('sia-home-recent-msg');
    try {
      const res = await fetch(`${BASE_URL}/conversations/${encodeURIComponent(SIA_USER_ID)}`);
      if (!res.ok) throw new Error('fetch failed');
      const data = await res.json();
      renderConversationList(data.conversations || []);
    } catch (e) {
      console.warn('[SIA Bot] No se pudo cargar el historial', e);
      convContainer.innerHTML = '<div style="padding:20px;text-align:center;color:#999;font-size:0.85rem;">No tienes conversaciones recientes.</div>';
      if (homeRecent) homeRecent.innerText = 'No hay mensajes recientes.';
    }
  }

  function renderConversationList(convs) {
    const convContainer = document.getElementById('sia-conversations-container');
    const homeRecent = document.getElementById('sia-home-recent-msg');
    convContainer.innerHTML = '';

    if (!convs.length) {
      convContainer.innerHTML = '<div style="padding:20px;text-align:center;color:#999;font-size:0.85rem;">Aún no tienes conversaciones. ¡Envía un mensaje para empezar!</div>';
      if (homeRecent) homeRecent.innerText = 'No hay mensajes recientes.';
      return;
    }

    if (homeRecent) homeRecent.innerText = convs[0].title || 'Conversación...';

    convs.forEach(conv => {
      const item = document.createElement('div');
      item.className = 'sia-conv-item';
      const dateStr = conv.created_at ? new Date(conv.created_at).toLocaleDateString() : '';
      item.innerHTML = `
        <div class="sia-conv-avatar">S</div>
        <div class="sia-conv-text">
          <strong>${conv.title || 'Chat de Soporte'}</strong>
          <span>${dateStr}</span>
        </div>
      `;
      item.addEventListener('click', () => loadConversation(conv.id));
      convContainer.appendChild(item);
    });
  }

  async function loadConversation(convId) {
    currentConversationId = convId;
    const msgsContainer = document.getElementById('sia-messages');
    const suggestionsDiv = document.getElementById('sia-suggestions');
    msgsContainer.innerHTML = '<div class="sia-msg bot typing" style="margin:0 auto;background:none;border:none;">Cargando mensajes...</div>';
    if (suggestionsDiv) suggestionsDiv.style.display = 'none';
    openView('chat');

    try {
      const res = await fetch(`${BASE_URL}/conversations/${convId}/messages`);
      const data = await res.json();
      msgsContainer.innerHTML = '';
      if (data.messages && data.messages.length) {
        data.messages.forEach(m => {
          let sources = null;
          try { sources = typeof m.sources === 'string' ? JSON.parse(m.sources) : m.sources; } catch (e) {}
          appendMessage(m.role, m.content, sources, false);
        });
      } else {
        appendMessage('bot', 'Esta conversación está vacía.', null, false);
      }
    } catch (e) {
      document.getElementById('sia-messages').innerHTML = '';
      appendMessage('bot', '⚠️ Error al cargar el historial de este chat.', null, false);
    }
  }

  function startNewConversation() {
    currentConversationId = null;
    document.getElementById('sia-messages').innerHTML = '';
    const suggestionsDiv = document.getElementById('sia-suggestions');
    if (suggestionsDiv) suggestionsDiv.style.display = 'flex';
    appendMessage('bot', '¡Hola! He iniciado una nueva conversación. ¿En qué te ayudo?', null, false);
    openView('chat');
  }

  function openActiveChat() {
    if (currentConversationId) {
      openView('chat');
    } else {
      fetchConversationsList().then(() => {
        const first = document.querySelector('#sia-conversations-container .sia-conv-item');
        if (first) first.click();
        else startNewConversation();
      });
    }
  }

  async function sendMessage() {
    const input = document.getElementById('sia-input');
    const sendBtn = document.getElementById('sia-send');
    const suggestionsDiv = document.getElementById('sia-suggestions');
    const q = input.value.trim();
    if (!q) return;

    input.value = '';
    sendBtn.disabled = true;
    if (suggestionsDiv) suggestionsDiv.style.display = 'none';

    appendMessage('user', q, null, false);

    const typing = document.createElement('div');
    typing.className = 'sia-msg bot typing';
    typing.textContent = 'Buscando en la base de datos...';
    document.getElementById('sia-messages').appendChild(typing);
    scrollToBottom();

    try {
      const res = await fetch(`${BASE_URL}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          question: q,
          user_id: SIA_USER_ID,
          conversation_id: currentConversationId || undefined
        })
      });
      const data = await res.json();
      typing.remove();
      if (data.conversation_id) currentConversationId = data.conversation_id;
      appendMessage('bot', data.answer.replace(/\n/g, '<br>'), data.sources, true, q);
    } catch (e) {
      typing.remove();
      appendMessage('bot', '⚠️ No se pudo conectar con el servidor. Verifica tu conexión.', null, false);
    }

    sendBtn.disabled = false;
    input.focus();
    scrollToBottom();
  }

  function appendMessage(role, html, sources, showRating, originalQuestion) {
    const div = document.createElement('div');
    div.className = 'sia-msg ' + (role === 'human' || role === 'user' ? 'user' : 'bot');
    div.innerHTML = html;

    if (sources && sources.length) {
      const s = document.createElement('div');
      s.className = 'sia-sources';
      s.innerHTML = '<br><strong>📖 Fuentes:</strong><br>' +
        sources.map(x => x.url && x.url.trim()
          ? `<a href="${x.url}" target="_blank">${x.seccion} — ${x.titulo}</a>`
          : `<span style="color:#FF6600;font-weight:600;display:block;">${x.seccion} — ${x.titulo}</span>`
        ).join('');
      div.appendChild(s);
    }

    if (showRating && (role === 'bot' || role === 'assistant')) {
      const rateCont = document.createElement('div');
      rateCont.className = 'sia-rating-container';
      const qText = originalQuestion || 'Pregunta no registrada';

      const goodBtn = document.createElement('button');
      goodBtn.className = 'sia-rating-btn'; goodBtn.innerHTML = '👍';
      goodBtn.addEventListener('click', () => sendRating('good', qText, html, rateCont));

      const badBtn = document.createElement('button');
      badBtn.className = 'sia-rating-btn'; badBtn.innerHTML = '👎';
      badBtn.addEventListener('click', () => sendRating('bad', qText, html, rateCont));

      rateCont.appendChild(goodBtn);
      rateCont.appendChild(badBtn);
      div.appendChild(rateCont);
    }

    document.getElementById('sia-messages').appendChild(div);
    scrollToBottom();
    return div;
  }

  async function sendRating(rating, question, answer, container) {
    container.innerHTML = '<span style="font-size:0.75rem;color:#999;margin-top:4px;">Gracias por tu feedback.</span>';
    let comment = '';
    if (rating === 'bad') comment = prompt('¿Por qué no fue útil la respuesta? (Opcional):') || '';
    try {
      await fetch(`${BASE_URL}/rate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          session_id: currentConversationId || SIA_USER_ID,
          question, answer, rating, comment
        })
      });
    } catch (e) { console.warn('[SIA Bot] Error enviando calificación.'); }
  }

  async function submitTicket() {
    const title = document.getElementById('ticket-title').value;
    const area = document.getElementById('ticket-area').value;
    const desc = document.getElementById('ticket-desc').value;
    const fileInput = document.getElementById('ticket-file');

    if (!title || !area) {
      alert('Por favor llena los campos obligatorios (Título y Área).');
      return;
    }

    const btn = document.getElementById('btn-submit-ticket');
    btn.disabled = true;
    btn.innerText = 'Enviando...';

    const formData = new FormData();
    formData.append('title', title);
    formData.append('area', area);
    formData.append('description', desc);
    formData.append('user_id', SIA_USER_ID);
    if (fileInput.files.length > 0) formData.append('file', fileInput.files[0]);

    try {
      const res = await fetch(`${BASE_URL}/ticket`, { method: 'POST', body: formData });
      if (res.ok) {
        alert('¡Ticket enviado exitosamente al equipo de soporte!');
        document.getElementById('ticket-title').value = '';
        document.getElementById('ticket-desc').value = '';
        document.getElementById('ticket-area').value = '';
        fileInput.value = '';
        openView('home');
      } else {
        alert('Hubo un error al enviar el ticket. Por favor revisa tu conexión.');
      }
    } catch (e) {
      alert('Error al contactar con el servidor. Por favor intenta más tarde.');
    } finally {
      btn.disabled = false;
      btn.innerText = 'Enviar ticket';
    }
  }

  // --- Event wiring ---

  function wireEvents() {
    document.getElementById('sia-fab').addEventListener('click', toggleWindow);
    document.getElementById('sia-close').addEventListener('click', toggleWindow);
    document.getElementById('sia-card-recent').addEventListener('click', openActiveChat);
    document.getElementById('sia-card-new').addEventListener('click', startNewConversation);
    document.getElementById('sia-card-ticket').addEventListener('click', () => openView('ticket'));
    document.getElementById('sia-back-to-list').addEventListener('click', () => openView('messages-list'));
    document.getElementById('sia-ticket-back').addEventListener('click', () => openView('home'));
    document.getElementById('sia-btn-new-conv').addEventListener('click', startNewConversation);
    document.getElementById('nav-btn-home').addEventListener('click', () => openView('home'));
    document.getElementById('nav-btn-messages-list').addEventListener('click', () => openView('messages-list'));
    document.getElementById('sia-send').addEventListener('click', sendMessage);
    document.getElementById('sia-input').addEventListener('keydown', e => { if (e.key === 'Enter') sendMessage(); });
    document.getElementById('btn-submit-ticket').addEventListener('click', submitTicket);
    document.querySelectorAll('.sia-suggestion-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        document.getElementById('sia-input').value = btn.getAttribute('data-text');
        document.getElementById('sia-suggestions').style.display = 'none';
        sendMessage();
      });
    });
  }

  // --- Lifecycle ---

  function mount() {
    if (initialized || !shouldShow()) return;
    initialized = true;
    injectStyles();
    injectHTML();
    wireEvents();
  }

  function unmount() {
    if (!initialized) return;
    initialized = false;
    currentConversationId = null;
    const root = document.getElementById('sia-chatbot-root');
    const styles = document.getElementById('sia-chatbot-styles');
    if (root) root.remove();
    if (styles) styles.remove();
  }

  function checkVisibility() {
    if (shouldShow() && !initialized) mount();
    else if (!shouldShow() && initialized) unmount();
  }

  document.addEventListener('DOMContentLoaded', checkVisibility);
  window.addEventListener('hashchange', checkVisibility);
})();
